import { n as e, r as t } from "./dist-By11B3Nf.js";
import { a as n } from "./dist-7tgynhKG.js";
import { n as r, t as i } from "./dist-B3lndwlS.js";
import * as a from "react";
import { useState as o } from "react";
import { jsx as s } from "react/jsx-runtime";
import * as c from "react-dom";
//#region ../../node_modules/.pnpm/@radix-ui+react-id@1.1.2_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-id/dist/index.mjs
var l = a.useId || (() => void 0), u = 0;
function d(t) {
	let [n, r] = a.useState(l());
	return e(() => {
		t || r((e) => e ?? String(u++));
	}, [t]), t || (n ? `radix-${n}` : "");
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-callback-ref@1.1.2_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
function f(e) {
	let t = a.useRef(e);
	return a.useEffect(() => {
		t.current = e;
	}), a.useMemo(() => ((...e) => t.current?.(...e)), []);
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-dismissable-layer@1.1.16_@types+react-dom@19.2.3_@types+react@19.2.17___24241290a75669b8fada33987215ac6a/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var p = Object.defineProperty, m = (e, t) => p(e, "name", {
	value: t,
	configurable: !0
}), h = "dismissableLayer.update", g = "dismissableLayer.pointerDownOutside", _ = "dismissableLayer.focusOutside", v, y = a.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), b = /* @__PURE__ */ a.forwardRef(/* @__PURE__ */ m(function(e, r) {
	let { disableOutsidePointerEvents: o = !1, deferPointerDownOutside: c = !1, onEscapeKeyDown: l, onPointerDownOutside: u, onFocusOutside: d, onInteractOutside: p, onDismiss: g, ..._ } = e, b = a.useContext(y), [x, ee] = a.useState(null), T = x?.ownerDocument ?? globalThis?.document, [, te] = a.useState({}), E = n(r, ee), D = Array.from(b.layers), [O] = [...b.layersWithOutsidePointerEventsDisabled].slice(-1), ne = O ? D.indexOf(O) : -1, k = x ? D.indexOf(x) : -1, A = b.layersWithOutsidePointerEventsDisabled.size > 0, j = k >= ne, M = a.useRef(!1), N = S((e) => {
		u?.(e), p?.(e), e.defaultPrevented || g?.();
	}, {
		ownerDocument: T,
		deferPointerDownOutside: c,
		isDeferredPointerDownOutsideRef: M,
		dismissableSurfaces: b.dismissableSurfaces,
		shouldHandlePointerDownOutside: a.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...b.branches].some((t) => t.contains(e));
			return j && !t;
		}, [b.branches, j])
	}), P = C((e) => {
		if (c && M.current) return;
		let t = e.target;
		[...b.branches].some((e) => e.contains(t)) || (d?.(e), p?.(e), e.defaultPrevented || g?.());
	}, T), F = x ? k === D.length - 1 : !1, I = f((e) => {
		e.key === "Escape" && (l?.(e), !e.defaultPrevented && g && (e.preventDefault(), g()));
	});
	return a.useEffect(() => {
		if (F) return T.addEventListener("keydown", I, { capture: !0 }), () => T.removeEventListener("keydown", I, { capture: !0 });
	}, [
		T,
		F,
		I
	]), a.useEffect(() => {
		if (x) return o && (b.layersWithOutsidePointerEventsDisabled.size === 0 && (v = T.body.style.pointerEvents, T.body.style.pointerEvents = "none"), b.layersWithOutsidePointerEventsDisabled.add(x)), b.layers.add(x), w(), () => {
			o && (b.layersWithOutsidePointerEventsDisabled.delete(x), b.layersWithOutsidePointerEventsDisabled.size === 0 && (T.body.style.pointerEvents = v));
		};
	}, [
		x,
		T,
		o,
		b
	]), a.useEffect(() => () => {
		x && (b.layers.delete(x), b.layersWithOutsidePointerEventsDisabled.delete(x), w());
	}, [x, b]), a.useEffect(() => {
		let e = /* @__PURE__ */ m(() => te({}), "handleUpdate");
		return document.addEventListener(h, e), () => document.removeEventListener(h, e);
	}, []), /* @__PURE__ */ s(i.div, {
		..._,
		ref: E,
		style: {
			pointerEvents: A ? j ? "auto" : "none" : void 0,
			...e.style
		},
		onFocusCapture: t(e.onFocusCapture, P.onFocusCapture),
		onBlurCapture: t(e.onBlurCapture, P.onBlurCapture),
		onPointerDownCapture: t(e.onPointerDownCapture, N.onPointerDownCapture)
	});
}, "DismissableLayer"));
function x() {
	let e = a.useContext(y), [t, n] = a.useState(null);
	return a.useEffect(() => {
		if (t) return e.dismissableSurfaces.add(t), () => {
			e.dismissableSurfaces.delete(t);
		};
	}, [t, e.dismissableSurfaces]), n;
}
m(x, "useDismissableLayerSurface");
var ee = /* @__PURE__ */ m(() => !0, "IS_TRUE");
function S(e, t) {
	let { ownerDocument: n = globalThis?.document, deferPointerDownOutside: r = !1, isDeferredPointerDownOutsideRef: i, dismissableSurfaces: o, shouldHandlePointerDownOutside: s = ee } = t, c = f(e), l = a.useRef(!1), u = a.useRef(!1), d = a.useRef(/* @__PURE__ */ new Map()), p = a.useRef(() => {});
	return a.useEffect(() => {
		function e() {
			u.current = !1, i.current = !1, d.current.clear();
		}
		m(e, "resetOutsideInteraction");
		function t() {
			return Array.from(d.current.values()).some(Boolean);
		}
		m(t, "isOutsideInteractionIntercepted");
		function a(e) {
			if (!u.current) return;
			let t = e.target;
			t instanceof Node && [...o].some((e) => e.contains(t)) || d.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				u.current && p.current();
			}, 0);
		}
		m(a, "handleInteractionCapture");
		function f(e) {
			u.current && d.current.set(e.type, !1);
		}
		m(f, "handleInteractionBubble");
		let h = /* @__PURE__ */ m((a) => {
			if (a.target && !l.current) {
				let o = function() {
					n.removeEventListener("click", p.current);
					let r = t();
					e(), r || T(g, c, f, { discrete: !0 });
				};
				if (m(o, "handleAndDispatchPointerDownOutsideEvent"), !s(a.target)) {
					n.removeEventListener("click", p.current), e(), l.current = !1;
					return;
				}
				let f = { originalEvent: a };
				u.current = !0, i.current = r && a.button === 0, d.current.clear(), !r || a.button !== 0 ? o() : (n.removeEventListener("click", p.current), p.current = o, n.addEventListener("click", p.current, { once: !0 }));
			} else n.removeEventListener("click", p.current), e();
			l.current = !1;
		}, "handlePointerDown"), _ = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of _) n.addEventListener(e, a, !0), n.addEventListener(e, f);
		let v = window.setTimeout(() => {
			n.addEventListener("pointerdown", h);
		}, 0);
		return () => {
			window.clearTimeout(v), n.removeEventListener("pointerdown", h), n.removeEventListener("click", p.current);
			for (let e of _) n.removeEventListener(e, a, !0), n.removeEventListener(e, f);
		};
	}, [
		n,
		c,
		r,
		i,
		o,
		s
	]), { onPointerDownCapture: /* @__PURE__ */ m(() => l.current = !0, "onPointerDownCapture") };
}
m(S, "usePointerDownOutside");
function C(e, t = globalThis?.document) {
	let n = f(e), r = a.useRef(!1);
	return a.useEffect(() => {
		let e = /* @__PURE__ */ m((e) => {
			e.target && !r.current && T(_, n, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return t.addEventListener("focusin", e), () => t.removeEventListener("focusin", e);
	}, [t, n]), {
		onFocusCapture: /* @__PURE__ */ m(() => r.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ m(() => r.current = !1, "onBlurCapture")
	};
}
m(C, "useFocusOutside");
function w() {
	let e = new CustomEvent(h);
	document.dispatchEvent(e);
}
m(w, "dispatchUpdate");
function T(e, t, n, { discrete: i }) {
	let a = n.originalEvent.target, o = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && a.addEventListener(e, t, { once: !0 }), i ? r(a, o) : a.dispatchEvent(o);
}
m(T, "handleAndDispatchCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-focus-scope@1.1.13_@types+react-dom@19.2.3_@types+react@19.2.17__@types_f4e54df32aabc713121ed047138ba1c5/node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var te = Object.defineProperty, E = (e, t) => te(e, "name", {
	value: t,
	configurable: !0
}), D = "focusScope.autoFocusOnMount", O = "focusScope.autoFocusOnUnmount", ne = {
	bubbles: !1,
	cancelable: !0
}, k = /* @__PURE__ */ a.forwardRef(/* @__PURE__ */ E(function(e, t) {
	let { loop: r = !1, trapped: o = !1, onMountAutoFocus: c, onUnmountAutoFocus: l, ...u } = e, [d, p] = a.useState(null), m = f(c), h = f(l), g = a.useRef(null), _ = n(t, p), v = a.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	a.useEffect(() => {
		if (o) {
			let e = function(e) {
				if (v.paused || !d) return;
				let t = e.target;
				d.contains(t) ? g.current = t : I(g.current, { select: !0 });
			}, t = function(e) {
				if (v.paused || !d) return;
				let t = e.relatedTarget;
				t !== null && (d.contains(t) || I(g.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && I(d);
			};
			E(e, "handleFocusIn"), E(t, "handleFocusOut"), E(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return d && r.observe(d, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		o,
		d,
		v.paused
	]), a.useEffect(() => {
		if (d) {
			re.add(v);
			let e = document.activeElement;
			if (!d.contains(e)) {
				let t = new CustomEvent(D, ne);
				d.addEventListener(D, m), d.dispatchEvent(t), t.defaultPrevented || (A(ae(M(d)), { select: !0 }), document.activeElement === e && I(d));
			}
			return () => {
				d.removeEventListener(D, m), setTimeout(() => {
					let t = new CustomEvent(O, ne);
					d.addEventListener(O, h), d.dispatchEvent(t), t.defaultPrevented || I(e ?? document.body, { select: !0 }), d.removeEventListener(O, h), re.remove(v);
				}, 0);
			};
		}
	}, [
		d,
		m,
		h,
		v
	]);
	let y = a.useCallback((e) => {
		if (!r && !o || v.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, n = document.activeElement;
		if (t && n) {
			let t = e.currentTarget, [i, a] = j(t);
			i && a ? !e.shiftKey && n === a ? (e.preventDefault(), r && I(i, { select: !0 })) : e.shiftKey && n === i && (e.preventDefault(), r && I(a, { select: !0 })) : n === t && e.preventDefault();
		}
	}, [
		r,
		o,
		v.paused
	]);
	return /* @__PURE__ */ s(i.div, {
		tabIndex: -1,
		...u,
		ref: _,
		onKeyDown: y
	});
}, "FocusScope"));
function A(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (I(r, { select: t }), document.activeElement !== n) return;
}
E(A, "focusFirst");
function j(e) {
	let t = M(e);
	return [N(t, e), N(t.reverse(), e)];
}
E(j, "getTabbableEdges");
function M(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ E((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
E(M, "getTabbableCandidates");
function N(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : P(r, { upTo: t }))) return r;
}
E(N, "findVisible");
function P(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
E(P, "isHidden");
function F(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
E(F, "isSelectableInput");
function I(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && F(e) && t && e.select();
	}
}
E(I, "focus");
var re = ie();
function ie() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = L(e, t), e.unshift(t);
		},
		remove(t) {
			e = L(e, t), e[0]?.resume();
		}
	};
}
E(ie, "createFocusScopesStack");
function L(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
E(L, "arrayRemove");
function ae(e) {
	return e.filter((e) => e.tagName !== "A");
}
E(ae, "removeLinks");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-portal@1.1.14_@types+react-dom@19.2.3_@types+react@19.2.17__@types+reac_7eb1b52c8eda669384dedb75fff1f459/node_modules/@radix-ui/react-portal/dist/index.mjs
var oe = Object.defineProperty, se = /* @__PURE__ */ a.forwardRef(/* @__PURE__ */ ((e, t) => oe(e, "name", {
	value: t,
	configurable: !0
}))(function(t, n) {
	let { container: r, ...o } = t, [l, u] = a.useState(!1);
	e(() => u(!0), []);
	let d = r || l && globalThis?.document?.body;
	return d ? c.createPortal(/* @__PURE__ */ s(i.div, {
		...o,
		ref: n
	}), d) : null;
}, "Portal")), R = 0, z = null;
function ce() {
	a.useEffect(() => {
		z ||= {
			start: le(),
			end: le()
		};
		let { start: e, end: t } = z;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), R++, () => {
			R === 1 && (z?.start.remove(), z?.end.remove(), z = null), R = Math.max(0, R - 1);
		};
	}, []);
}
function le() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
//#endregion
//#region ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var B = function() {
	return B = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, B.apply(this, arguments);
};
function ue(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function de(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll-bar@2.3.8_@types+react@19.2.17_react@19.2.7/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var V = "right-scroll-bar-position", H = "width-before-scroll-bar", fe = "with-scroll-bars-hidden", pe = "--removed-body-scroll-bar-size";
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.2.17_react@19.2.7/node_modules/use-callback-ref/dist/es2015/assignRef.js
function U(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.2.17_react@19.2.7/node_modules/use-callback-ref/dist/es2015/useRef.js
function me(e, t) {
	var n = o(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.2.17_react@19.2.7/node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var he = typeof window < "u" ? a.useLayoutEffect : a.useEffect, ge = /* @__PURE__ */ new WeakMap();
function _e(e, t) {
	var n = me(t || null, function(t) {
		return e.forEach(function(e) {
			return U(e, t);
		});
	});
	return he(function() {
		var t = ge.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || U(e, null);
			}), i.forEach(function(e) {
				r.has(e) || U(e, a);
			});
		}
		ge.set(n, e);
	}, [e]), n;
}
//#endregion
//#region ../../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@19.2.17_react@19.2.7/node_modules/use-sidecar/dist/es2015/medium.js
function ve(e) {
	return e;
}
function ye(e, t) {
	t === void 0 && (t = ve);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function be(e) {
	e === void 0 && (e = {});
	var t = ye(null);
	return t.options = B({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region ../../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@19.2.17_react@19.2.7/node_modules/use-sidecar/dist/es2015/exports.js
var xe = function(e) {
	var t = e.sideCar, n = ue(e, ["sideCar"]);
	if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var r = t.read();
	if (!r) throw Error("Sidecar medium not found");
	return a.createElement(r, B({}, n));
};
xe.isSideCarExport = !0;
function Se(e, t) {
	return e.useMedium(t), xe;
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.17_react@19.2.7/node_modules/react-remove-scroll/dist/es2015/medium.js
var Ce = be(), W = function() {}, G = a.forwardRef(function(e, t) {
	var n = a.useRef(null), r = a.useState({
		onScrollCapture: W,
		onWheelCapture: W,
		onTouchMoveCapture: W
	}), i = r[0], o = r[1], s = e.forwardProps, c = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, f = e.shards, p = e.sideCar, m = e.noRelative, h = e.noIsolation, g = e.inert, _ = e.allowPinchZoom, v = e.as, y = v === void 0 ? "div" : v, b = e.gapMode, x = ue(e, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), ee = p, S = _e([n, t]), C = B(B({}, x), i);
	return a.createElement(a.Fragment, null, d && a.createElement(ee, {
		sideCar: Ce,
		removeScrollBar: u,
		shards: f,
		noRelative: m,
		noIsolation: h,
		inert: g,
		setCallbacks: o,
		allowPinchZoom: !!_,
		lockRef: n,
		gapMode: b
	}), s ? a.cloneElement(a.Children.only(c), B(B({}, C), { ref: S })) : a.createElement(y, B({}, C, {
		className: l,
		ref: S
	}), c));
});
G.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, G.classNames = {
	fullWidth: H,
	zeroRight: V
};
//#endregion
//#region ../../node_modules/.pnpm/get-nonce@1.0.1/node_modules/get-nonce/dist/es2015/index.js
var we, Te = function() {
	if (we) return we;
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region ../../node_modules/.pnpm/react-style-singleton@2.2.3_@types+react@19.2.17_react@19.2.7/node_modules/react-style-singleton/dist/es2015/singleton.js
function Ee() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = Te();
	return t && e.setAttribute("nonce", t), e;
}
function De(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Oe(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var ke = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = Ee()) && (De(t, n), Oe(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, Ae = function() {
	var e = ke();
	return function(t, n) {
		a.useEffect(function() {
			return e.add(t), function() {
				e.remove();
			};
		}, [t && n]);
	};
}, je = function() {
	var e = Ae();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, Me = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, Ne = function(e) {
	return parseInt(e || "", 10) || 0;
}, Pe = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		Ne(n),
		Ne(r),
		Ne(i)
	];
}, Fe = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return Me;
	var t = Pe(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, Ie = je(), K = "data-scroll-locked", Le = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${fe} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${K}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${V} {
    right: ${s}px ${r};
  }
  
  .${H} {
    margin-right: ${s}px ${r};
  }
  
  .${V} .${V} {
    right: 0 ${r};
  }
  
  .${H} .${H} {
    margin-right: 0 ${r};
  }
  
  body[${K}] {
    ${pe}: ${s}px;
  }
`;
}, Re = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, ze = function() {
	a.useEffect(function() {
		return document.body.setAttribute(K, (Re() + 1).toString()), function() {
			var e = Re() - 1;
			e <= 0 ? document.body.removeAttribute(K) : document.body.setAttribute(K, e.toString());
		};
	}, []);
}, Be = function(e) {
	var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
	ze();
	var o = a.useMemo(function() {
		return Fe(i);
	}, [i]);
	return a.createElement(Ie, { styles: Le(o, !t, i, n ? "" : "!important") });
}, Ve = !1;
if (typeof window < "u") try {
	var q = Object.defineProperty({}, "passive", { get: function() {
		return Ve = !0, !0;
	} });
	window.addEventListener("test", q, q), window.removeEventListener("test", q, q);
} catch {
	Ve = !1;
}
var J = Ve ? { passive: !1 } : !1, He = function(e) {
	return e.tagName === "TEXTAREA";
}, Ue = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !He(e) && n[t] === "visible");
}, We = function(e) {
	return Ue(e, "overflowY");
}, Ge = function(e) {
	return Ue(e, "overflowX");
}, Ke = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), Ye(e, r)) {
			var i = Xe(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, qe = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, Je = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, Ye = function(e, t) {
	return e === "v" ? We(t) : Ge(t);
}, Xe = function(e, t) {
	return e === "v" ? qe(t) : Je(t);
}, Ze = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, Qe = function(e, t, n, r, i) {
	var a = Ze(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = Xe(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && Ye(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, Y = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, $e = function(e) {
	return [e.deltaX, e.deltaY];
}, et = function(e) {
	return e && "current" in e ? e.current : e;
}, tt = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, nt = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, rt = 0, X = [];
function it(e) {
	var t = a.useRef([]), n = a.useRef([0, 0]), r = a.useRef(), i = a.useState(rt++)[0], o = a.useState(je)[0], s = a.useRef(e);
	a.useEffect(function() {
		s.current = e;
	}, [e]), a.useEffect(function() {
		if (e.inert) {
			document.body.classList.add(`block-interactivity-${i}`);
			var t = de([e.lockRef.current], (e.shards || []).map(et), !0).filter(Boolean);
			return t.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${i}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${i}`), t.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${i}`);
				});
			};
		}
	}, [
		e.inert,
		e.lockRef.current,
		e.shards
	]);
	var c = a.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !s.current.allowPinchZoom;
		var i = Y(e), a = n.current, o = "deltaX" in e ? e.deltaX : a[0] - i[0], c = "deltaY" in e ? e.deltaY : a[1] - i[1], l, u = e.target, d = Math.abs(o) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = Ke(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = Ke(d, u)), !m) return !1;
		if (!r.current && "changedTouches" in e && (o || c) && (r.current = l), !l) return !0;
		var h = r.current || l;
		return Qe(h, t, e, h === "h" ? o : c, !0);
	}, []), l = a.useCallback(function(e) {
		var n = e;
		if (!(!X.length || X[X.length - 1] !== o)) {
			var r = "deltaY" in n ? $e(n) : Y(n), i = t.current.filter(function(e) {
				return e.name === n.type && (e.target === n.target || n.target === e.shadowParent) && tt(e.delta, r);
			})[0];
			if (i && i.should) {
				n.cancelable && n.preventDefault();
				return;
			}
			if (!i) {
				var a = (s.current.shards || []).map(et).filter(Boolean).filter(function(e) {
					return e.contains(n.target);
				});
				(a.length > 0 ? c(n, a[0]) : !s.current.noIsolation) && n.cancelable && n.preventDefault();
			}
		}
	}, []), u = a.useCallback(function(e, n, r, i) {
		var a = {
			name: e,
			delta: n,
			target: r,
			should: i,
			shadowParent: at(r)
		};
		t.current.push(a), setTimeout(function() {
			t.current = t.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), d = a.useCallback(function(e) {
		n.current = Y(e), r.current = void 0;
	}, []), f = a.useCallback(function(t) {
		u(t.type, $e(t), t.target, c(t, e.lockRef.current));
	}, []), p = a.useCallback(function(t) {
		u(t.type, Y(t), t.target, c(t, e.lockRef.current));
	}, []);
	a.useEffect(function() {
		return X.push(o), e.setCallbacks({
			onScrollCapture: f,
			onWheelCapture: f,
			onTouchMoveCapture: p
		}), document.addEventListener("wheel", l, J), document.addEventListener("touchmove", l, J), document.addEventListener("touchstart", d, J), function() {
			X = X.filter(function(e) {
				return e !== o;
			}), document.removeEventListener("wheel", l, J), document.removeEventListener("touchmove", l, J), document.removeEventListener("touchstart", d, J);
		};
	}, []);
	var m = e.removeScrollBar, h = e.inert;
	return a.createElement(a.Fragment, null, h ? a.createElement(o, { styles: nt(i) }) : null, m ? a.createElement(Be, {
		noRelative: e.noRelative,
		gapMode: e.gapMode
	}) : null);
}
function at(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.17_react@19.2.7/node_modules/react-remove-scroll/dist/es2015/sidecar.js
var ot = Se(Ce, it), st = a.forwardRef(function(e, t) {
	return a.createElement(G, B({}, e, {
		ref: t,
		sideCar: ot
	}));
});
st.classNames = G.classNames;
//#endregion
//#region ../../node_modules/.pnpm/aria-hidden@1.2.6/node_modules/aria-hidden/dist/es2015/index.js
var ct = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, Z = /* @__PURE__ */ new WeakMap(), Q = /* @__PURE__ */ new WeakMap(), $ = {}, lt = 0, ut = function(e) {
	return e && (e.host || ut(e.parentNode));
}, dt = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = ut(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, ft = function(e, t, n, r) {
	var i = dt(t, Array.isArray(e) ? e : [e]);
	$[n] || ($[n] = /* @__PURE__ */ new WeakMap());
	var a = $[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		!e || s.has(e) || (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		!e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (Z.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				Z.set(e, c), a.set(e, l), o.push(e), c === 1 && i && Q.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), lt++, function() {
		o.forEach(function(e) {
			var t = Z.get(e) - 1, i = a.get(e) - 1;
			Z.set(e, t), a.set(e, i), t || (Q.has(e) || e.removeAttribute(r), Q.delete(e)), i || e.removeAttribute(n);
		}), lt--, lt || (Z = /* @__PURE__ */ new WeakMap(), Z = /* @__PURE__ */ new WeakMap(), Q = /* @__PURE__ */ new WeakMap(), $ = {});
	};
}, pt = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || ct(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), ft(r, i, n, "aria-hidden")) : function() {
		return null;
	};
};
//#endregion
export { k as a, f as c, se as i, d as l, st as n, b as o, ce as r, x as s, pt as t };

//# sourceMappingURL=es2015-Dfq2CQHn.js.map